import { AUTHZED_RELATIONS } from '@/modules/authentication/rolesConstants';

import { EmployeeForm_RoleFragment } from './graphql/GetEmployee.generated';

export function rolesGrantAllClientAccess(
  roles: EmployeeForm_RoleFragment[],
  selectedRoleIds: string[]
) {
  const assignedRoles = roles.filter((role) =>
    selectedRoleIds.includes(role.id)
  );
  return assignedRoles.some((role) =>
    role.capabilities?.some(
      (cap) =>
        cap.authzedRelationName === AUTHZED_RELATIONS.advisorClientAllClients
    )
  );
}
